module.exports = __webpack_public_path__ + "static/media/smart-logo@3x.07693cd4.png";